/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */
import {Vue} from 'vue-property-decorator';
import {MutationTree} from 'vuex';
import {UgcNotificationItemInterface, UgcNotificationStateInterface} from '@/store/modules/ugc-notification/types';

/**
 * Ugc notification mutations.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const mutations: MutationTree<UgcNotificationStateInterface> = {
    /**
     * Add notification item set to state.
     *
     * @param {UgcItemStateInterface} state
     * @param {UgcItemInterface[]} items
     */
    setItems(state: UgcNotificationStateInterface, items: UgcNotificationItemInterface[]): void {
        Vue.set(state, 'items', items.map((item: UgcNotificationItemInterface) => {
            const existing: UgcNotificationItemInterface | undefined =
                state.items.find((i: UgcNotificationItemInterface) => item.id === i.id);

            item.presented = (undefined !== existing) ? existing.presented : false;

            return item;
        }));
    },

    /**
     * Update notification item to be presented.
     *
     * @param {UgcNotificationStateInterface} state
     * @param {UgcNotificationItemInterface} item
     */
    setPresented(state: UgcNotificationStateInterface, item: UgcNotificationItemInterface): void {
        // find address item and update with address
        for (const notificationItem of state.items) {
            if (notificationItem.id === item.id) {
                notificationItem.presented = true;
                break;
            }
        }
    },
};
